import { Injectable } from "@angular/core";
import { StorageService } from "./storage.service";
import { Token, UserInfo, Organisation } from "../../models";
import { CONFIGURATION } from "../../app.constants";

@Injectable()
export class CurrentUserService {

    constructor(private storageService: StorageService) { }

    public get token(): Token {
        let token = this.storageService.getItem("auth");

        return token;
    }
    public set token(token: Token) {
        this.storageService.setItem("auth", token);
    }

    public get userInfo(): UserInfo {
        let userInfo = this.storageService.getItem("userInfo");

        if (userInfo === null) {
            userInfo = new UserInfo();
            userInfo.organisation = new Organisation();
        }

        return userInfo;
    }
    public set userInfo(userInfo: UserInfo) {
        this.storageService.setItem("userInfo", userInfo);
    }

    // Returns true if the current user has one of the global admins privileges
    public IsGlobalAdmin() {
        return (this.token && (this.token.globalRoleCode === CONFIGURATION.globalRoles.netidAdmin || this.token.globalRoleCode === CONFIGURATION.globalRoles.netidSiteAdmin ) );
    }

    // Returns true if the current user has the diocesan admin privileges
    public IsDiocesanAdmin() {
        return (this.token && this.token.globalRoleCode === CONFIGURATION.globalRoles.netidDiocesanAdmin);
    }

    // Returns true if current user is the admin of their main organisation
    public IsOrgAdmin() {
        return (this.token && (this.token.organisationRoleCode === CONFIGURATION.organisationRoles.administrator));
    }

    // Returns true if current user is a diocesan user, but not a diocesan admin
     public IsDiocesanUser() {
        return (this.token && this.token.globalRoleCode === CONFIGURATION.globalRoles.netidDiocesanUser);
    }

    // Returns true if current user is a netid user
    public IsNetidUser() {
        return (this.token && this.token.globalRoleCode === CONFIGURATION.globalRoles.netidUser);
    }

    public IsSiteAdmin() {
        return (this.token && this.token.globalRoleCode === CONFIGURATION.globalRoles.netidSiteAdmin);
    }

    public isActivated() {
        return (this.token && this.token.sso_isActivated === "True");
    }

    public isLinked() {
        return (this.token && this.token.sso_isLinked === "True");
    }

    public getConnectionNames(): string[] {
        if (!this.token) {
            return [];
        }
        
        const connectionNamesRaw = this.token.connection_names;
        
        if (!connectionNamesRaw) {
            return [];
        }
        
        // Handle if backend sends as string instead of array
        if (typeof connectionNamesRaw === 'string') {
            // Split by comma, semicolon, or pipe and clean up
            const names = connectionNamesRaw.split(/[,;|]/).map((name: string) => name.trim()).filter((name: string) => name.length > 0);
            return names;
        }
        
        // Handle if backend sends as array
        if (Array.isArray(connectionNamesRaw) && connectionNamesRaw.length > 0) {
            return connectionNamesRaw;
        }
        return [];
    }
}



// WEBPACK FOOTER //
// ./src/app/services/shared/currentUser.service.ts